<template>
  <router-view/>
  <a
    class="floating-whatsapp"
    :href="whatsappUrl"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp Blue Speed Construction"
  >
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path
        d="M16.04 3.2C9.02 3.2 3.3 8.86 3.3 15.82c0 2.22.59 4.39 1.71 6.3L3.2 28.8l6.86-1.79a12.82 12.82 0 0 0 5.98 1.49c7.02 0 12.74-5.66 12.74-12.62S23.06 3.2 16.04 3.2Zm0 22.99c-1.88 0-3.72-.5-5.32-1.45l-.38-.22-4.07 1.06 1.08-3.93-.25-.4a10.2 10.2 0 0 1-1.56-5.43c0-5.68 4.72-10.3 10.51-10.3 5.8 0 10.51 4.62 10.51 10.3s-4.72 10.37-10.52 10.37Zm5.76-7.73c-.32-.16-1.88-.92-2.17-1.02-.29-.11-.5-.16-.71.16-.21.32-.82 1.02-1 1.23-.18.21-.37.24-.68.08-.32-.16-1.34-.49-2.56-1.57-.95-.84-1.59-1.88-1.78-2.2-.18-.32-.02-.49.14-.65.15-.14.32-.37.47-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.55-.08-.16-.71-1.7-.97-2.33-.26-.61-.52-.53-.71-.54h-.61c-.21 0-.55.08-.84.4-.29.32-1.1 1.07-1.1 2.61 0 1.54 1.13 3.03 1.29 3.24.16.21 2.22 3.35 5.38 4.7.75.32 1.34.51 1.79.65.75.24 1.44.2 1.99.12.61-.09 1.88-.76 2.14-1.49.26-.74.26-1.37.18-1.49-.08-.13-.29-.21-.61-.37Z"
      />
    </svg>
  </a>
</template>
<script>
import { whatsappLink } from "@/config/company";

export default {
  name: "App",

  data() {
    return {
      whatsappUrl: whatsappLink(),
    };
  },
};
</script>
<style>
.floating-whatsapp {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  width: 58px;
  height: 58px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: #25d366;
  color: #ffffff;
  box-shadow: 0 16px 36px rgba(18, 105, 55, 0.28);
  transition:
    transform 180ms ease,
    box-shadow 180ms ease,
    background 180ms ease;
}

.floating-whatsapp:hover {
  transform: translateY(-3px);
  background: #20bd5a;
  box-shadow: 0 20px 42px rgba(18, 105, 55, 0.34);
}

.floating-whatsapp svg {
  width: 33px;
  height: 33px;
  fill: currentColor;
}

@media (max-width: 640px) {
  .floating-whatsapp {
    right: 18px;
    bottom: 18px;
    width: 54px;
    height: 54px;
  }

  .floating-whatsapp svg {
    width: 30px;
    height: 30px;
  }
}
</style>
